import React from "react";
import "./LineDots.scss";

interface Props {
  height?: string;
  width?: string;
  x1: string;
  y1: string;
  x2: string;
  y2: string;

  /**
   * Colour of the dots. Default is --page-accent.
   */
  colour?: string;
}

/**
 * Component to draw a line of dots.
 * 
 * @status review
 * - code style (not using BEM)
 */
export const LineDots: React.FC<Props> = ({ height, width, x1, y1, x2, y2, colour }) => {

  const style: React.CSSProperties = colour != null
    ? { stroke: colour }
    : {};

  return (
    <svg className="line-dots-container" height={height} width={width}>
      <line className="line-dots" x1={x1} y1={y1} x2={x2} y2={y2} style={style} />
    </svg>
  );
};
